/**
 * Shared guard for the branded-ID constructors (BrandSlug, SegmentId, OrgId, ...).
 *
 * Each constructor normalizes its raw input first (trim, and for BrandSlug
 * lowercase), then hands the normalized value here. The message names the raw
 * input, not the normalized one, so a caller can see what was actually passed.
 */
export function assertNonEmpty(normalized: string, raw: string, label: string): string {
  if (!normalized) {
    throw new Error(`Invalid ${label}: empty value (raw: "${raw}")`);
  }
  return normalized;
}
